module.exports = __webpack_public_path__ + "static/media/model-pajero-06-swb.9b48fa81.webp";